// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as React from 'react';

const TITLE = 'Google';

interface GoogleProps {
  isMultiColor?: boolean;
}

export function Google({ isMultiColor }: GoogleProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      aria-label={TITLE}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{TITLE}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.1 11.2273C20.1 10.5182 20.0364 9.83637 19.9182 9.18182H10.5V13.05H15.8818C15.65 14.3 14.9455 15.3591 13.8864 16.0682V18.5773H17.1182C19.0091 16.8364 20.1 14.2727 20.1 11.2273Z"
        fill={isMultiColor ? '#4285F4' : 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4998 20.9999C13.1998 20.9999 15.4635 20.1044 17.118 18.5771L13.8862 16.068C12.9907 16.668 11.8453 17.0226 10.4998 17.0226C7.89529 17.0226 5.69075 15.2635 4.90439 12.8999H1.56348V15.4908C3.20893 18.7589 6.59075 20.9999 10.4998 20.9999Z"
        fill={isMultiColor ? '#34A853' : 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.90455 12.9C4.70455 12.3 4.59091 11.6591 4.59091 11C4.59091 10.341 4.70455 9.70005 4.90455 9.10005V6.50914H1.56364C0.886364 7.85914 0.5 9.38641 0.5 11C0.5 12.6137 0.886364 14.141 1.56364 15.491L4.90455 12.9Z"
        fill={isMultiColor ? '#FBBC05' : 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4998 4.97727C11.968 4.97727 13.2862 5.48182 14.3226 6.47273L17.1908 3.60455C15.4589 1.99091 13.1953 1 10.4998 1C6.59075 1 3.20893 3.24091 1.56348 6.50909L4.90439 9.1C5.69075 6.73636 7.8953 4.97727 10.4998 4.97727Z"
        fill={isMultiColor ? '#EA4335' : 'currentColor'}
      />
    </svg>
  );
}
